<template>
  <div>
    <interaction-hint v-if="!readonly">
      Напечатайте ответ на клавиатуре
    </interaction-hint>
    <v-text-field
      :value="value"
      @input="answer"
      :disabled="readonly"
      label="Ваш ответ"
    />
  </div>
</template>
<script type="text/babel">
import InteractionHint from './InteractionHint'
export default {
  name: 'InteractionInline',
  props: {
    value: {
      required: true
    },
    readonly: {
      default: false
    }
  },
  methods: {
    answer(value) {
      this.$emit('input', value)
    }
  },
  components: {
    InteractionHint
  }
}
</script>
